import { getUsers } from '@services/users/admin/get-users';
import { getById } from '@services/users/admin/get-by-id';

export const usersSDK = {
    admin: {
        getMany: getUsers,
        getById,
    },
};
